<template>
  <div class="public-footer" id="public-footer-id">
    <div class="footer-main">
      <div class="main-row1">
        <div class="row1-title">友情链接</div>
        <div class="row1-url">
          <a class="url-span" href="http://www.nrta.gov.cn" target="_blank">
            国家广播电视总局
          </a>
          <a class="url-span" href="http://www.gdrcjlzx.cn/" target="_blank">
            广播影视人才交流中心
          </a>
          <a
            class="url-span"
            href="https://training.nrta.gov.cn/"
            target="_blank"
          >
            智慧广电学院
          </a>
          <a class="url-span" href="http://www.sarftlearn.com/" target="_blank">
            传媒云苑
          </a>
        </div>
      </div>
      <div class="main-row2">
        <span>Copyright 2019 www.nrtatalent.cn All Rights Reserved.</span>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
          >京ICP备2021003548号-2</a
        >
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11040202120019"
          target="_blank"
        >
          <img
            src="../assets/image/police.png"
            alt="京公网安备11040202120019"
          />
          京公网安备11040202120019
        </a>
      </div>
      <div class="main-row3">
        <span>版权所有：国家广播电视总局人才交流中心</span>
        <span>运营管理：北京新广汇贤人力资源管理有限责任公司</span>
        <span>技术支持：北京聚师网教育科技有限公司</span>
      </div>
      <div class="main-row3">
        <span>监督服务热线: 4006903008</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PublicFooter'
}
</script>
<style lang="scss" scoped>
.public-footer {
  background: #1c6ace;

  .footer-main {
    width: 1200px;
    margin: 0 auto;
    padding: 35px 0 32px 0;

    .main-row1 {
      margin-bottom: 30px;
      padding: 0 0 19px 49px;
      border-bottom: 1px solid rgba(119, 193, 255, 0.54);
      .row1-title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        margin-bottom: 18px;
        padding-left: 12px;
      }
      .row1-url {
        a {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fff;
          padding: 0 12px;
          &:hover {
            color: #fff;
          }
        }
        a:not(a:last-child) {
          border-right: 1px solid rgba($color: #fff, $alpha: 0.43);
        }
      }
    }
    .main-row2 {
      margin-bottom: 23px;
      padding: 0 0 0 61px;
      span,
      a {
        margin-right: 51px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        > img {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
      }
    }
    .main-row3 {
      padding: 0 0 0 61px;
      padding-bottom: 23px;
      span {
        margin-right: 34px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
      }
    }
  }
}
</style>
